import React from 'react';
import { useNavigate } from 'react-router-dom';
import ThemeToggle from '../ThemeToggle';

const NotFound = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center bg-background-light dark:bg-background-dark transition-colors">
      <div className="absolute top-5 right-5"><ThemeToggle /></div>
      <div className="max-w-lg w-full">
        <h1 className="text-8xl font-black bg-gradient-to-b from-primary-dark to-accent-yellow bg-clip-text text-transparent drop-shadow-sm mb-6 select-none">404</h1>
        <h2 className="text-2xl font-semibold text-black dark:text-white mb-4">ไม่พบหน้าที่คุณต้องการ</h2>
        <p className="text-gray-600 dark:text-gray-300 mb-8 leading-relaxed">ลิงก์อาจหมดอายุหรือถูกลบออกไปแล้ว หากคิดว่าเป็นข้อผิดพลาด โปรดลองรีเฟรชหรือแจ้งตัวแทนระบบ</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => navigate(token ? '/dashboard' : '/login')}
            className="gradient-btn px-6 py-3 rounded-lg text-white font-medium shadow-light dark:shadow-lightdark hover:shadow-card dark:hover:shadow-carddark transition"
          >{token ? 'กลับไปหน้า Dashboard' : 'ไปหน้าเข้าสู่ระบบ'}</button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
